import type { A11yProfile } from './types';

// Bedürfnisbasierte Profile (nicht zustands-/diagnosebasiert): benannt nach dem,
// was der Besucher ERREICHEN will (besser lesen, weniger Ablenkung), nicht nach
// einer unterstellten Behinderung. Bewusst KEINE Versprechen wie „macht
// screenreader-kompatibel". Alle referenzierten Features liegen im Default-Set
// von index.ts; sonst greift das Aktivierungs-Gating in FeatureGrid nicht (es
// synchronisiert nur config.features).
export const PROFILES: A11yProfile[] = [
  {
    id: 'readability',
    nameKey: 'profile.readability',
    descKey: 'profile.readability.desc',
    iconId: 'eye',
    features: ['contrast', 'text-size', 'spacing', 'dyslexia-font', 'link-highlight'],
    featureSettings: { 'text-size': 140, contrast: 'high' },
  },
  {
    id: 'focus',
    nameKey: 'profile.focus',
    descKey: 'profile.focus.desc',
    iconId: 'focus',
    features: ['animation-stop', 'hide-images', 'reading-mask'],
  },
  {
    id: 'calm-colors',
    nameKey: 'profile.calmColors',
    descKey: 'profile.calmColors.desc',
    iconId: 'saturation',
    features: ['saturation', 'animation-stop'],
    featureSettings: { saturation: 'low' },
  },
  {
    id: 'read-aloud',
    nameKey: 'profile.readAloud',
    descKey: 'profile.readAloud.desc',
    iconId: 'tts',
    features: ['tts', 'spacing', 'text-size'],
    featureSettings: { 'text-size': 130 },
  },
];
